(function() {
  'use strict';

  angular.module('component.faqs')
    .component('faqsList', {
      templateUrl: 'app/components/faqs/list.html',
      controller: 'FAQsController',
      controllerAs: 'faqsCtrl'
    });
})();
